export const TWILIO_TECH_CHECK_SELECT_WEBCAM = "twilio-tech-check-select-device";
export const TWILIO_TECH_CHECK_SELECT_AUDIO = "twilio-tech-check-select-audio";
export const TWILIO_TECH_CHECK_SMS = "twilio-tech-check-sms";
export const DOCUMENT_UPLOADER_PRIMARY_SIGNER = "document-uploader-primary-signer";
export const DOCUMENT_UPLOADER_COSIGNER_REQUIRED = "document-uploader-cosigner-required";
export const DOCUMENT_UPLOADER_ERROR_MSG = "document-uploader-error-msg";
export const DOCUMENT_UPLOADER_REQUIREMENTS_INSTRUCTIONS =
  "document-uploader-requirements-instructions";
export const TECH_CHECK_SELECT_DEVICES = "tech-check-select-devices";
